import { PermissionState } from "modules/deviceInfo";

type DailyDeviceState =
  | "undefined-mediadevices"
  | "not-found"
  | "unknown"
  | "idle"
  | "pending"
  | "not-supported"
  | "granted"
  | "blocked"
  | "in-use"
  | "constraints-invalid"
  | "constraints-none-specified";

export const getPermissionLevel = (
  deviceState: DailyDeviceState,
): PermissionState => {
  switch (deviceState) {
    case "idle":
      return PermissionState.IDLE;
    case "pending":
      return PermissionState.PENDING;
    case "granted":
      return PermissionState.GRANTED;
    case "blocked":
      return PermissionState.BLOCKED;
    case "in-use":
      return PermissionState.IN_USE;
    case "not-found":
      return PermissionState.NOT_FOUND;
    case "unknown":
    case "not-supported":
    case "constraints-invalid":
    case "constraints-none-specified":
    default:
      return PermissionState.UNKNOWN;
  }
};
